/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    Input,
} from '@angular/core';

import { ClrIconModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { L10nService } from '@vmw/ngx-vip';

import { TooltipModule } from 'ng/modules/tooltip/tooltip.module';
import * as l10n from './avi-full-modal-preview-message.l10n';
import './avi-full-modal-preview-message.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * A component for displaying full modal preview messages.
 *
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'avi-full-modal-preview-message',
    templateUrl: './avi-full-modal-preview-message.component.html',
    standalone: true,
    imports: [
        ClrIconModule,
        TooltipModule,
        CommonModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AviFullModalPreviewMessageComponent {
    @Input()
    public header: string;

    @Input()
    public statusText: string;

    @Input()
    public statusIcon: string;

    @Input()
    public tooltipText: string;

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
